var React = require('react');

function Plus (props) {
    return React.createElement("svg",props,[React.createElement("line",{"x1":"6.75","y1":"12.2998","x2":"17.25","y2":"12.2998","stroke":"currentcolor","strokeWidth":"1.5","strokeLinecap":"square","key":0}),React.createElement("line",{"x1":"12.0537","y1":"7.17969","x2":"12.0537","y2":"17.6797","stroke":"currentcolor","strokeWidth":"1.5","strokeLinecap":"square","key":1})]);
}

Plus.defaultProps = {"width":"24","height":"25","viewBox":"0 0 24 25"};

module.exports = Plus;

Plus.default = Plus;
